import { Injectable, inject } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable, shareReplay } from 'rxjs';
import { environment } from '../../../environments/environment';

export interface AxaEntity {
  entityCode: string;
  entityDescription: string;
  signatoryName: string | null;
  signatoryRole: string | null;
  dpoEmail: string | null;
}

export interface AxaEntityApiResponse {
  status: boolean;
  message: string;
  data: AxaEntity[];
}

@Injectable({
  providedIn: 'root',
})
export class AxaEntityService {
  private readonly http = inject(HttpClient);
  private readonly apiUrl = `${environment.coreApiUrl}/api/v1/axa-entities`;
  private entities$?: Observable<AxaEntityApiResponse>;

  getAll(): Observable<AxaEntityApiResponse> {
    if (!this.entities$) {
      this.entities$ = this.http
        .get<AxaEntityApiResponse>(this.apiUrl)
        .pipe(shareReplay(1));
    }

    return this.entities$;
  }
}